function formatPhone(phone) {
  if (!phone) return "";

  // Check for international
  if (phone.match(/^[0+]/)) return phone;

  let numbers = phone.replace(/[^0-9]/g, "");
  if (!numbers) return "";

  if (numbers.length <= 7) {
    return `${numbers.substr(0, 3)}-${numbers.substr(3, 4)}`;
  } else if (numbers.length < 10) {
    return `${numbers.substr(0, 3)}-${numbers.substr(3, 4)}-${numbers.substr(7, 3)}`;
  } else if (numbers.length == 10) {
    return `${numbers.substr(0, 3)}-${numbers.substr(3, 3)}-${numbers.substr(6, 4)}`;
  } else {
    return `${numbers.substr(0, 3)}-${numbers.substr(3, 3)}-${numbers.substr(
      6,
      4,
    )} x${numbers.substr(10)}`;
  }
}

function Contact({ contact }: { contact: be.Contact }): JSX.Element {
  return (
    <div>
      <dd className="mt-3 text-gray-500">
        {contact.name && <span className="block">{contact.name}</span>}
        {contact.phone && <span className="block">{formatPhone(contact.phone)}</span>}
        {contact.altPhone && <span className="block">{formatPhone(contact.altPhone)}</span>}
        {contact.email && <span className="block">{contact.email}</span>}
      </dd>
    </div>
  );
}

export default Contact;
